<template>
  <div>
    <div class="navBar">
      <router-link :to="{ name: 'home' }">
        <img class="smallLogo" src="../assets/cropped-pak.png" />
      </router-link>

      <ul class="social nav navbar-toolbar navbar-right navbar-toolbar-right">
        <li title="facebook">
          <a href="https://www.facebook.com/Pakomak.mk/" target="_blank"
            ><i class="fab fa-facebook-square"></i
          ></a>
        </li>
        <li title="instagram">
          <a href="https://www.instagram.com/pakomak/" target="_blank"
            ><i class="fab fa-instagram"></i
          ></a>
        </li>
        <li title="youtube">
          <a
            href="https://www.youtube.com/channel/UCJxg2nVbzzFDswn6OrKZmlA"
            target="_blank"
            ><i class="fab fa-youtube"></i
          ></a>
        </li>
        <li title="website">
          <a href="https://pakomak.com.mk/" target="_blank"
            ><i class="fas fass fa-globe"></i
          ></a>
        </li>
        <li title="logout">
          <a href="#" v-on:click="logout">
            <i class="fas fass fa-sign-out-alt"></i>
          </a>
        </li>
      </ul>
    </div>
    <div class="menu d-flex flex-column">
      <!-- <ul class="nav flex-column">
        <li class="nav-item">
          <div class="align-left link">
            <router-link :to="{ name: 'users' }">
              <i class="fa floatLeft" aria-hidden="true"
                ><img class="faImg faImgPng" src="../assets/users.png"
              /></i>
              <div class="icon-text">Users</div></router-link
            >
          </div>
        </li>
        <li class="nav-item">
          <span class="align-left link"
            ><router-link :to="{ name: 'brands' }">
              <i class="fa floatLeft" aria-hidden="true"
                ><img class="faImg" src="../assets/brands.svg"
              /></i>
              <span class="icon-text">Brands</span></router-link
            ></span
          >
        </li>
        <li class="nav-item">
          <span class="align-left link"
            ><router-link :to="{ name: 'packaging' }">
              <i class="fa floatLeft" aria-hidden="true"
                ><img class="faImg" src="../assets/beverages.svg"
              /></i>
              <span class="icon-text">Packaging</span></router-link
            ></span
          >
        </li>
        <li class="nav-item">
          <span class="align-left"
            ><router-link :to="{ name: 'providers' }">
              <i class="fa floatLeft" aria-hidden="true"
                ><img class="faImg" src="../assets/providers.svg"
              /></i>
              <span class="icon-text">Providers</span></router-link
            ></span
          >
        </li>
        <li class="nav-item">
          <span class="align-left"
            ><router-link :to="{ name: 'vouchers' }">
              <i class="fa floatLeft" aria-hidden="true"
                ><img class="faImg" src="../assets/vouchers.svg"
              /></i>
              <span class="icon-text">Vouchers</span></router-link
            ></span
          >
        </li>
        <li class="nav-item">
          <span class="align-left link"
            ><router-link :to="{ name: 'audit' }">
              <i class="fa floatLeft" aria-hidden="true"
                ><img class="faImg" src="../assets/history.svg"
              /></i>
              <span class="icon-text">History</span></router-link
            ></span
          >
        </li>
        <li class="nav-item">
          <span class="align-left link"
            ><router-link :to="{ name: 'machines' }">
              <i class="fa floatLeft" aria-hidden="true"
                ><img class="faImg" src="../assets/machine.svg"
              /></i>
              <span class="icon-text">Machines</span></router-link
            ></span
          >
        </li>
        <li class="nav-item">
          <span class="align-left link"
            ><router-link :to="{ name: 'transactions' }">
              <i class="fa floatLeft" aria-hidden="true"
                ><img class="faImg" src="../assets/in_transaction1.svg"
              /></i>
              <span class="icon-text">Input transactions</span></router-link
            ></span
          >
        </li>
        <li class="nav-item">
          <span class="align-left link"
            ><router-link :to="{ name: 'transactionsoutgoing' }">
              <i class="fa floatLeft" aria-hidden="true"
                ><img class="faImg" src="../assets/out_transaction1.svg"
              /></i>
              <span class="icon-text">Output transactions</span></router-link
            ></span
          >
        </li>
        <li class="nav-item">
          <span class="align-left link"
            ><router-link :to="{ name: 'admins' }">
              <i class="fa floatLeft" aria-hidden="true"
                ><img class="faImg faImgPng" src="../assets/admin.png"
              /></i>
              <span class="icon-text">Admins</span></router-link
            ></span
          >
        </li>
      </ul> -->
      <ul v-if="sizeFlag" class="nav flex-column">
       <li v-on:click="moveUp()" class="pointer">
          <div class="align-left link icons-wrap" id="icons">
            <i
              class="fa floatLeft icons icons-wrap active-arrows"
              aria-hidden="true"
            >
              <img
                class="faImg"
                v-bind:class="{ faImgPng: !isFirst }"
                src="../assets/menu-arrow-up.png"
              />
            </i>
          </div>
        </li> 
        <li
          class="nav-item"
          v-for="(item, i) in menuItems.slice(topElem, botomElem)"
          :key="i"
          step="20"
        >
          <div class="align-left link">
            <router-link :to="{ name: item.linkTo }">
              <i class="fa floatLeft" aria-hidden="true"
                ><img
                  v-bind:class="{ faImgPng: !item.svgFlag }"
                  class="faImg"
                  v-bind:src="item.imgSrc"
              /></i>
              <div class="icon-text">{{ item.linkText }}</div></router-link
            >
          </div>
        </li>
        <li v-on:click="moveDown()" class="pointer">
          <div class="align-left link icons-wrap" id="icons">
            <i class="fa floatLeft icons icons-wrap" aria-hidden="true">
              <img
                class="faImg"
                v-bind:class="{ faImgPng: !isLast }"
                src="../assets/menu-arrow-down.png"
              />
            </i>
          </div>
        </li>
      </ul>
      <ul v-else-if="!sizeFlag" class="nav flex-column">
        <li class="nav-item" v-for="(item, i) in menuItems" :key="i">
          <div class="align-left link">
            <router-link :to="{ name: item.linkTo }">
              <i class="fa floatLeft" aria-hidden="true"
                ><img
                  v-bind:class="{ faImgPng: !item.svgFlag }"
                  class="faImg"
                  v-bind:src="item.imgSrc"
              /></i>
              <div class="icon-text">{{ item.linkText }}</div></router-link
            >
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import store from './../store';
export default {
  name: 'Navigation',

  data() {
    return {
      activateItem: false,
      sizeFlag: false,
      topElem: 0,
      botomElem: 8,
      isLast: false,
      isFirst: true,
      window: {
        width: 0,
        height: 0,
      },
      miniMenuItems: [],
      menuItems: [
        {
          linkTo: 'users',
          imgSrc: require('../assets/users.png'),
          linkText: 'Users',
          svgFlag: false,
        },
  
        {
          linkTo: 'providers',
          imgSrc: require('../assets/providers.svg'),
          linkText: 'Providers',
          svgFlag: true,
        },
        {
          linkTo: 'categories',
          imgSrc: require('../assets/categories.svg'),
          linkText: 'Categories',
          svgFlag: true,
        },
        {
          linkTo: 'vouchers',
          imgSrc: require('../assets/vouchers.svg'),
          linkText: 'Vouchers',
          svgFlag: true,
        },
       
        {
          linkTo: 'machines',
          imgSrc: require('../assets/machine.svg'),
          linkText: 'Machines',
          svgFlag: true,
        },
        {
          linkTo: 'transactions',
          imgSrc: require('../assets/in_transaction1.svg'),
          linkText: 'Input transactions',
          svgFlag: true,
        },
        {
          linkTo: 'transactionsoutgoing',
          imgSrc: require('../assets/out_transaction1.svg'),
          linkText: 'Output transactions',
          svgFlag: true,
        },
        {
          linkTo: 'notifications',
          imgSrc: require('../assets/notifications.svg'),
          linkText: 'Notifications',
          svgFlag: true,
        },
        {
          linkTo: 'audit',
          imgSrc: require('../assets/history.svg'),
          linkText: 'History',
          svgFlag: true,
        },
        {
          linkTo: 'brands',
          imgSrc: require('../assets/brands.svg'),
          linkText: 'Brands',
          svgFlag: true,
        },
        {
          linkTo: 'packaging',
          imgSrc: require('../assets/beverages.svg'),
          linkText: 'Packagings',
          svgFlag: true,
        },
        {
          linkTo: 'reviewundefined',
          imgSrc: require('../assets/iconfinder_edit-document-note-writing-review_3209355.svg'),
          linkText: 'Review transactions',
          svgFlag: false,
        },
        {
          linkTo: 'manualpoints',
          imgSrc: require('../assets/coins.svg'),
          linkText: 'Manual points',
          svgFlag: false,
        },
        {
          linkTo: 'admins',
          imgSrc: require('../assets/admin.png'),
          linkText: 'Admins',
          svgFlag: false,
        },
      ],
    };
  },
  created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  watch: {},
  methods: {
    logout() {
      this.$store.dispatch('logout');
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      if (this.window.width <= 1440) {
        this.sizeFlag = true;
      } else {
        this.sizeFlag = false;
      }
    },
    moveUp() {
      if (this.topElem == 0) {
        this.isFirst = true;
        return;
      } else {
        this.isFirst = false;
        this.isLast = false;
        this.topElem = this.topElem - 1;
        this.botomElem = this.topElem + 8;
      }
      if (this.topElem == 0) {
        this.isLast = false;
        this.isFirst = true;
      }
    },
    moveDown() {
      if (this.botomElem == this.menuItems.length) {
        this.isLast = true;
        return;
      } else {
        this.isLast = false;
        this.isFirst = false;
        this.botomElem = this.botomElem + 1;
        this.topElem = this.botomElem - 8;
        if (this.botomElem == this.menuItems.length) {
          this.isLast = true;
          this.isFirst = false;
        }
      }
    },
  },
};
</script>


<style src="../css/style.css"></style>
